import React, { useEffect, useRef, useState } from 'react';
import automateImg from './images/automationImg.png';
import driveImg from './images/drive sales.png';
import activeImg from './images/active.png';

const Build_Chatboat = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // IntersectionObserver → trigger fade when section enters viewport
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el); // trigger only once
        }
      },
      { threshold: 0.2 } // 20% visible
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`chatbot-section ${visible ? 'show' : ''}`}
    >


      <div
        className="px-5 x-xxl-5 px-6 mx-auto position-relative"
        style={{ maxWidth: '74%', zIndex: 1, marginTop: 70 }}
      >
        {/* === Heading === */}
        <div>
          <h2
            style={{
              fontSize: '44px',
              fontFamily: "'Inter'",
              fontWeight: 650,
              color: '#242121ff',
              lineHeight: 1.2,
            }}
          >
            Build Smart{' '}
            <span style={{ color: '#1DB954' }}>WhatsApp</span>{' '}
            Chatbots that convert
          </h2>

          <p
            style={{
              fontSize: '1.1rem',
              color: '#413e3e',
              fontWeight: 300,
              fontFamily: 'Poppins',
              marginTop: '-0.5rem',
            }}
          >
            Automate support, drive sales and stay always-on with an AI-powered
            WhatsApp experience.
          </p>
        </div>

        <div style={{ height: 24 }} />

        {/* === Feature Cards (3) === */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 20,
          }}
        >
          {[
            {
              title: 'Automate Queries',
              img: automateImg,
              desc: 'Resolve 80% of common questions using intents, KB search, and smart fallbacks to human agents.',
              list: ['Intent detection', 'Knowledge base answers', 'Multi-language'],
            },
            {
              title: 'Drive Sales',
              img: driveImg,
              desc: 'Run campaigns, send catalogs, collect payments, and recover carts with message templates.',
              list: ['Click-to-WhatsApp ads', 'Product catalogs', 'Payment links'],
            },
            {
              title: 'Stay Active 24×7',
              img: activeImg,
              desc: 'Always-on assistance with SLAs, escalation rules, and sentiment-aware responses.',
              list: ['24/7 availability', 'Auto-escalations', 'CSAT prompts'],
            },
          ].map((card, i) => (
            <div
              key={i}
              style={{
                background: 'linear-gradient(180deg,#ffffff 0%,#F5F7FA 100%)',
                borderRadius: 20,
                padding: 22,
                border: '1px solid rgba(0,0,0,0.08)',
              }}
            >
              {/* Icon + Title */}
              <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 12,
                    border: '1px solid #e3effc',
                    background: '#e8f2ff',
                    display: 'grid',
                    placeItems: 'center',
                    flex: '0 0 auto',
                  }}
                >
                  <img
                    src={card.img}
                    alt={card.title}
                    style={{ width: 26, height: 26, objectFit: 'contain' }}
                  />
                </div>

                <div>
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 20,
                      color: '#242121ff',
                      fontFamily: 'Inter',
                    }}
                  >
                    {card.title}
                  </div>

                  <p
                    style={{
                      marginTop: 6,
                      color: '#525252',
                      fontSize: 15,
                      fontFamily: 'Poppins',
                      fontWeight: 300,
                      lineHeight: 1.2,
                    }}
                  >
                    {card.desc}
                  </p>
                </div>
              </div>

              {/* Bullet Points */}
              <ul
                style={{
                  listStyle: 'none',
                  marginLeft: '1rem',
                  marginTop: '0.5rem',
                  fontSize: 14,
                  fontFamily: 'Poppins',
                  fontWeight: 300,
                  color: '#1f2937',
                }}
              >
                {card.list.map((t, j) => (
                  <li
                    key={j}
                    style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                  >
                    <span
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: 999,
                        background: '#10B981',
                        display: 'inline-block',
                      }}
                    />
                    {t}
                  </li>
                ))}
              </ul>

              {/* Buttons */}
              <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
                <button
                  style={{
                    background: '#0EA764',
                    color: '#fff',
                    border: 'none',
                    padding: '10px 14px',
                    borderRadius: 10,
                    fontWeight: 600,
                    marginLeft: '3rem',
                  }}
                >
                  Preview
                </button>
                <button
                  style={{
                    background: '#fff',
                    color: '#0f172a',
                    border: '1px solid #D1D5DB',
                    padding: '10px 14px',
                    borderRadius: 10,
                    fontWeight: 500,
                  }}
                >
                  Learn more
                </button>
              </div>
            </div>
          ))}
        </div>

        <div style={{ height: 24 }} />
      </div>

      {/* === Animation CSS === */}
      <style>{`
        .chatbot-section {
          opacity: 0;
          transform: translateY(50px); /* start lower */
          transition: opacity 0.8s ease, transform 0.8s ease;
          will-change: opacity, transform;
        }
        .chatbot-section.show {
          opacity: 1;
          transform: translateY(0); /* move into place */
        }
      `}</style>
    </section>
  );
};

export default Build_Chatboat;
